// extracted by mini-css-extract-plugin
module.exports = {"actions":"style_actions__1-CRK","perfil":"style_perfil__m8aB8"};